export default ({ app }, inject) => {
  inject('noCartMode', () => {
    return ['wetzeu', 'wellfareu'].includes(process.env.VENDOR)
  })

  inject('hideStockAvailabilityColumns', (p) => {
    return process.env.VENDOR === 'wellfar' && !app.$auth.loggedIn;
  })
}
